import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/AuthContext";
import { SiteProvider } from "./lib/SiteContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Energy from "./pages/Energy";
import Water from "./pages/Water";
import Weather from "./pages/Weather";
import DataSources from "./pages/DataSources";
import Settings from "./pages/Settings";
import BatteryLive from "./pages/Battery";
import Devices from "./pages/Devices";

import "./App.css";

function RequireAuth({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen grid place-items-center bg-background">
        <div className="w-4 h-4 rounded-full border-2 border-zinc-700 border-t-foreground animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/onboarding" element={<RequireAuth><Onboarding /></RequireAuth>} />

            <Route element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path="/energy" element={<Energy />} />
              <Route path="/water" element={<Water />} />
              <Route path="/weather" element={<Weather />} />
              <Route path="/data-sources" element={<DataSources />} />
              <Route path="/devices" element={<Devices />} />
              <Route path="/battery" element={<BatteryLive />} />
              <Route path="/settings" element={<Settings />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </SiteProvider>
    </AuthProvider>
  );
}
